import { render } from "./DraftConfirmBlock.vue?vue&type=template&id=6a758e21&scoped=true"
import script from "./DraftConfirmBlock.vue?vue&type=script&lang=js"
export * from "./DraftConfirmBlock.vue?vue&type=script&lang=js"

import "./DraftConfirmBlock.vue?vue&type=style&index=0&id=6a758e21&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a758e21"]])

export default __exports__